/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentDetailByIdQueryResponse, WebAppGetFragmentDetailByIdPathParams, WebAppGetFragmentDetailById404 } from "../models/WebAppGetFragmentDetailById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetFragmentDetailById } from "../axios/webAppGetFragmentDetailById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetFragmentDetailByIdQueryKey = (id: WebAppGetFragmentDetailByIdPathParams["id"]) => ["api-v2", { url: '/web-app/v1/fragments/:id', params: {id:id} }] as const

export type WebAppGetFragmentDetailByIdQueryKey = ReturnType<typeof webAppGetFragmentDetailByIdQueryKey>

export function webAppGetFragmentDetailByIdQueryOptions(id: WebAppGetFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetFragmentDetailByIdQueryKey(id)
        return queryOptions<WebAppGetFragmentDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailById404>, WebAppGetFragmentDetailByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetFragmentDetailById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one fragment by id
 * {@link /web-app/v1/fragments/:id}
 */
export function useWebAppGetFragmentDetailById<TData = WebAppGetFragmentDetailByIdQueryResponse, TQueryData = WebAppGetFragmentDetailByIdQueryResponse, TQueryKey extends QueryKey = WebAppGetFragmentDetailByIdQueryKey>(id: WebAppGetFragmentDetailByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetFragmentDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetFragmentDetailByIdQueryKey(id)
         

         const query = useQuery({
          ...webAppGetFragmentDetailByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetFragmentDetailById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}